/* 劉備（字玄德） */
import { gd, landing } from '../../core/kit.ts';
import { defineHero, U, S } from '../define.ts';

export default defineHero({
  id: 'liubei', name: '劉備', sub: '字玄德', faction: 'shu', role: '指揮', weapon: 'sword',
  look: { dual: true, weaponName: '雙股劍', head: 'guan', beard: 'goatee', bigEars: true, robe: true, fx: '#9be07a', c: { cloth: '#2c6a45', sleeve: '#2c6a45', armor: '#d9b45c' } },
  skills: [
    // v0.4.2：聖光術、護駕改成點選目標（點誰就是誰）；戰意改成自己與附近友將一起加
    ['聖光術', 'heal', '點選友軍：治療 {300/400/500/600} 生命（可點自己）；點選敵人：造成一半傷害。', { x: { k: 'nuke', heal: [300, 400, 500, 600], click: true, selfOk: true, fx: 'heal' }, aim: U(480), cd: 22, mp: [100, 125, 150, 175] }],
    ['護駕', 'command', '點選一名友方武將，2 秒後把他拉到劉備身旁。', { x: { k: 'pullally', delay: 2 }, aim: U(6000), cd: [105, 85, 65, 45], mp: [125, 150, 175, 200] }],
    ['戰意', 'buff', '劉備與 500 內的友方武將攻擊 +{10/18/26/34}、防禦 +{2/3/4/5}，持續 30 秒。', { x: { k: 'buff', to: 'near', r: 500, heroOnly: true, atk: [10, 18, 26, 34], armor: [2, 3, 4, 5], dur: 30 }, aim: S(500), cd: 20, mp: [60, 70, 80, 90] }],
    ['鼓舞', 'command', '全場我軍攻擊 +20、防禦 +10，持續 {15/20/25} 秒。', { x: { k: 'buff', to: 'all', atk: 20, armor: 10, dur: [15, 20, 25] }, aim: S(0), cd: 150, mp: [200, 250, 300] }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    pullally(u, a, X) {
      const hs = this.units.filter((t) => t.alive && t.team === u.team && t.kind === 'hero' && t !== u && gd(u.x, u.y, t.x, t.y) > 300);
      // 點選的友將（v0.4.2）；電腦沒有點選，選生命最低的
      const t = a.tid ? hs.find((o) => o.id === a.tid) : hs.sort((p, q) => p.hp / p.maxHp - q.hp / q.maxHp)[0];
      if (!t) { this.xRefund(u, a); return; }
      this.fx({ k: 'warn', x: t.x, y: t.y, r: 40, t: X.delay || 1 });
      this.later(X.delay || 1, () => {
        if (!u.alive || !t.alive) return;
        const q = landing(u.x, u.y, u.x - u.f * 50, u.y);
        this.fx({ k: 'puff', x: t.x, y: t.y }); t.x = q[0]; t.y = q[1]; t.act = null; t.input.moveTo = null; t.input.target = null; this.fx({ k: 'puff', x: t.x, y: t.y });
      });
    },
  },
});
